import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import axios from "axios";

import LoginForm from "./component/loginForm";

import { handleLogin } from "../../store/user";
import { getSetting } from "../../store/scheduler";

const Login = () => {
  const user = useSelector((state) => state?.user?.data[0]);

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      dispatch(handleLogin(user));
      navigate("/mypage");
    }
  }, [user]);

  // 일정번호 복호화
  const getScheduleNo = async () => {
    const noValue = JSON.parse(sessionStorage.getItem("sharedEvent"));
    if (!noValue) return null;

    const url = "/etc/decrypt";
    const body = { encrypted: noValue };

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        return res.data.decrypted;
      }
    } catch (error) {
      return null;
    }
  };

  // 캘린더 설정 조회
  const getSchedulerSetting = async (mber) => {
    const url = "/api/toktokSettingList";
    const body = { mberNo: mber.mberNo };
    const res = await axios.post(url, body);

    if (res.request.status === 200) {
      dispatch(getSetting(res.data));

      const scheduleNo = await getScheduleNo();
      if (scheduleNo && parseInt(scheduleNo)) {
        navigate(`/mypage/detailEvent/${scheduleNo}`);
        return;
      }

      const couponCode = JSON.parse(sessionStorage.getItem("coupon"));
      if (couponCode) {
        navigate(`/mypage/notify#3`);
        return;
      }

      navigate("/mypage");
    }
  };

  return <LoginForm getSchedulerSetting={getSchedulerSetting} />;
};

export default Login;
